export default __webpack_public_path__ + "static/media/Labor.c7b3dbad.svg";